/**
 * avatars/items/index.js
 * Thư viện hình học 3D chuẩn Voxel / Minecraft (Layer 2 & Props)
 * Thiết kế sắc sảo, 100% đồng nhất ngôn ngữ khối hộp (Voxel Art).
 * Quản lý ủy quyền các bộ phận trang bị theo cấu trúc module phân tách.
 */

import { pickContrastColor, addChinStrap } from './shared.js';
import { createHair } from './hair.js';
import { createHorns } from './horns.js';
import { createBeard } from './beard.js';
import { createWings } from './wings.js';
import { createTail } from './tail.js';
import { createHat } from './hat.js';
import { createEyewear } from './eyewear.js';
import { createMask } from './mask.js';
import { createBodyAccessory } from './body-accessories.js';
import { createHeldItem } from './held-items.js';

export {
  pickContrastColor,
  addChinStrap,
  createHair,
  createHorns,
  createBeard,
  createWings,
  createTail,
  createHat,
  createEyewear,
  createMask,
  createBodyAccessory,
  createHeldItem
};

export class AvatarItemsLibrary {
  constructor() {
    this.disposables = [];
  }

  pickContrastColor(baseColor, palette) {
    return pickContrastColor(baseColor, palette);
  }

  addChinStrap(hatGroup, headSize, topY, material, withBuckle = false) {
    return addChinStrap(this, hatGroup, headSize, topY, material, withBuckle);
  }

  createHair(style, headSize, hairColor = '#1e293b') {
    return createHair(this, style, headSize, hairColor);
  }

  createHorns(type, headSize, hornColor = '#ea580c') {
    return createHorns(this, type, headSize, hornColor);
  }

  createBeard(type, headSize, color = '#94a3b8') {
    return createBeard(this, type, headSize, color);
  }

  createWings(type, torsoW, torsoH, torsoD, wingColor = '#ffffff') {
    return createWings(this, type, torsoW, torsoH, torsoD, wingColor);
  }

  createTail(type, torsoW, torsoH, torsoD, tailColor = '#b91c1c') {
    return createTail(this, type, torsoW, torsoH, torsoD, tailColor);
  }

  createHat(type, headSize) {
    return createHat(this, type, headSize);
  }

  createEyewear(type, headSize) {
    return createEyewear(this, type, headSize);
  }

  createMask(type, headSize) {
    return createMask(this, type, headSize);
  }

  createBodyAccessory(type, torsoW, torsoH, torsoD, opts = {}) {
    return createBodyAccessory(this, type, torsoW, torsoH, torsoD, opts);
  }

  createHeldItem(type) {
    return createHeldItem(this, type);
  }

  dispose() {
    this.disposables.forEach((item) => {
      if (item && typeof item.dispose === 'function') {
        item.dispose();
      }
    });
    this.disposables = [];
  }
}
